var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',[_c('v-container',{staticClass:"shop fill-height py-6 px-4 px-1 px-md-4"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }